"use client"

import * as React from "react"
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table"
import { Button } from "@/components/ui/button"
import { DashboardSectionTitle } from "@/components/dashboard-section-heading"
import { cn } from "@/lib/utils"
import {
  QUALITY_CLINICAL_MATRIX,
  QUALITY_CLINICAL_TOP,
  QUALITY_CLINICAL_WATCH,
} from "@/lib/mock/evaluation-quality-dashboard"

export function QualityClinicalBlock() {
  return (
    <section aria-labelledby="quality-clinical-heading" className="flex flex-col gap-4">
      <div className="flex flex-col gap-1">
        <DashboardSectionTitle as="h2" id="quality-clinical-heading">
          Clinical learning
        </DashboardSectionTitle>
        <p className="text-sm text-muted-foreground">124 active sites · 412 preceptors</p>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <SiteList title="Top performing" sites={QUALITY_CLINICAL_TOP} />
        <SiteList title="Watch" sites={QUALITY_CLINICAL_WATCH} watch />
      </div>

      <div className="overflow-x-auto rounded-xl border border-border">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Site</TableHead>
              <TableHead className="text-right">Site</TableHead>
              <TableHead className="text-right">Preceptor</TableHead>
              <TableHead className="text-right">Exposure</TableHead>
              <TableHead className="text-right">Supervision</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {QUALITY_CLINICAL_MATRIX.map(row => (
              <TableRow key={row.site}>
                <TableCell className="font-medium">{row.site}</TableCell>
                <TableCell className="text-right tabular-nums">{row.siteScore.toFixed(1)}</TableCell>
                <TableCell className="text-right tabular-nums">{row.preceptor.toFixed(1)}</TableCell>
                <TableCell className="text-right tabular-nums">{row.exposure.toFixed(1)}</TableCell>
                <TableCell className="text-right tabular-nums">{row.supervision.toFixed(1)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>

      <Button variant="outline" size="sm" className="w-fit">
        View clinical health
      </Button>
    </section>
  )
}

function SiteList({
  title,
  sites,
  watch,
}: {
  title: string
  sites: typeof QUALITY_CLINICAL_TOP
  watch?: boolean
}) {
  return (
    <div className="rounded-xl border border-border/60 bg-muted/20 p-3">
      <p className="mb-2 text-xs font-medium uppercase tracking-wide text-muted-foreground">
        {title}
      </p>
      <ul className="flex flex-col gap-2 text-sm">
        {sites.map(site => (
          <li key={site.id} className="flex items-center justify-between gap-2">
            <span className="text-foreground">{site.name}</span>
            <span
              className={cn(
                "tabular-nums",
                watch ? "text-[color:var(--chart-4)]" : "text-chart-2",
              )}
            >
              {site.score.toFixed(1)}
              {site.trend === "down" ? " ↓" : site.trend === "up" ? " ↑" : ""}
            </span>
          </li>
        ))}
      </ul>
    </div>
  )
}
